export default __webpack_public_path__ + "static/media/chatting-ss.e748cb4c.svg";